// Shared radio-group primitive (s154 D-154 2a/2b) — the single implementation for every 0c/0e
// radiogroup (card selects, drawer selects, yes_no gates, select headerFields).
//
// 2a: horizontal layout that wraps on narrow widths; NO boxed/white container — the radios sit
//     directly on the card/drawer background like the other inputs.
// 2b: the ENTIRE label is the click target (the <label> wraps the native <input type="radio">).
// Unanswered state: value "" (or no match) → no option checked, visibly distinct from any choice.
// Value strings are preserved exactly (options carry {value,label}); yes_no maps "true"/"false".

interface RadioOptionsProps {
  /** Unique per field+row so radios in different records/fields don't share a group. */
  name: string;
  /** The currently stored value ("" = unanswered → nothing checked). */
  value: string;
  options: ReadonlyArray<{ value: string; label: string }>;
  onChange: (value: string) => void;
  readOnly?: boolean;
  id?: string;
  testIdPrefix?: string;
  className?: string;
}

export function RadioOptions({ name, value, options, onChange, readOnly, id, testIdPrefix, className }: RadioOptionsProps) {
  return (
    <div
      role="radiogroup"
      id={id}
      data-testid={testIdPrefix}
      className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 pt-1 ${className ?? ""}`}
    >
      {options.map((o) => (
        <label
          key={o.value}
          className="inline-flex items-center gap-1.5 text-sm cursor-pointer select-none"
        >
          <input
            type="radio"
            name={name}
            value={o.value}
            checked={value === o.value}
            disabled={readOnly}
            onChange={() => { if (!readOnly) onChange(o.value); }}
            className="accent-[#4F6B51] cursor-pointer"
            data-testid={testIdPrefix ? `${testIdPrefix}-opt-${o.value}` : undefined}
          />
          <span>{o.label}</span>
        </label>
      ))}
    </div>
  );
}
